import { render, staticRenderFns } from "./TeamMashup.vue?vue&type=template&id=0bd577fa&scoped=true"
import script from "./TeamMashup.vue?vue&type=script&lang=js"
export * from "./TeamMashup.vue?vue&type=script&lang=js"
import style0 from "./TeamMashup.vue?vue&type=style&index=0&id=0bd577fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd577fa",
  null
  
)

export default component.exports